import type { PublicCreator } from "@/lib/api";

type RosterItemPlayer = {
  id: string;
  displayName: string;
  profileImageUrl?: string | null;
  isCaptain: boolean;
};

type RosterItemProps = {
  player: RosterItemPlayer;
  number: number;
};

const RosterItem = ({
  player,
  number,
}: RosterItemProps) => {
  return (
    <div className="cs-roster-item">
      <div className="left-section">
              <span className="cs-roster-item-number">
        {String(number).padStart(2, "0")}
      </span>

      {/* {player.profileImageUrl ? (
        <img
          className="cs-roster-item-avatar"
          src={player.profileImageUrl}
          alt=""
        />
      ) : (
        <span className="cs-roster-item-avatar cs-avatar-blank">
          {player.displayName.charAt(0)}
        </span>
      )} */}

      <div className="cs-roster-item-info">
        <strong>{player.displayName}</strong>

        {/* <span>
          {player.isCaptain ? "Captain" : "Role"}
        </span> */}
      </div>

      </div>


      <div className="cs-roster-item-ranking">
        <p>{player.isCaptain ? "Captain" : "Role"}</p>
        
      </div>
    </div>
  );
};

export default RosterItem;